<template>
  <div class="ChukuReceipts app-container">
    <div class="detailsTitle" style=" margin-bottom: 0;">
      <h4>出库单据</h4>
    </div>
    <div ref="searchBox">
      <div class="formBox margbot">
        <el-form ref="searchForm" :inline="true" class="demo-form-inline" label-width="100px">
          <div class="formItemBox">
          <el-form-item label="出库单号:">
            <el-input class="ipt" v-model="searchForm.outstockNo" maxlength="50" placeholder="请输入出库单号"
              size="mini"></el-input>
          </el-form-item>
          <el-form-item label="出库日期:">
            <div style="display: flex;">
            <el-date-picker v-model="searchForm.outstockDateStart" size="mini" kehu="date"
              placeholder="选择出库开始日期" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            -
            <el-date-picker v-model="searchForm.outstockDateEnd" size="mini" kehu="date"
              placeholder="选择出库结束日期" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select v-model="searchForm.primaryCustomerTaxId" size="mini" filterable clearable placeholder="请选择一级货主">
              <el-option v-for="(item, index) in OwnerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="searchForm.customerTaxId" size="mini" filterable clearable placeholder="请选择二级货主">
              <el-option v-for="(item, index) in OwnerData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="货权方:">
            <el-select
            v-model="searchForm.ownerCustomerTaxId"
            size="mini"
            filterable
            clearable
            placeholder="请选择货权方">
              <el-option
                v-for="(item,index) in HQData"
                :key="index"
                :label="item.custerName"
                :value="item.taxpayerNumber"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="车牌号:">
            <el-input class="ipt" v-model="searchForm.outstockPlateNumber" maxlength="50"
              placeholder="请输入车牌号" size="mini"></el-input>
          </el-form-item>

          <el-form-item label="提货单号:">
            <el-input class="ipt"  v-model="searchForm.billNo" maxlength="50" placeholder="请输入提货单号"
              size="mini"></el-input>
          </el-form-item>
          <el-form-item label="外部单号:">
            <el-input v-model="searchForm.outBillNo" maxlength="50" placeholder="请输入外部单号"
              size="mini"></el-input>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="searchForm.steelMillName" size="mini" clearable placeholder="请选择">
              <el-option v-for="item in steelMillNameData" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
         </div>
          <el-form-item style="margin-bottom: 0;">
            <el-button type="primary" size="mini" @click="chaxun" btnCode="003P01EB001" v-if="btnFlg[0]">
              查询
            </el-button>
            <el-button type="primary" size="mini" btnCode="003P01EB002" v-if="btnFlg[1]" @click="chongzhi">
              重置
            </el-button>
            <el-button type="primary" size="mini" btnCode="003M2V0100" v-if="btnFlg[6]" @click="printChukudan">
              打印出库单
            </el-button>
            <el-button type="primary" size="mini" @click="editXieCheCost" btnCode="003P01EB005" v-if="btnFlg[4]">
              修改装车费
            </el-button>
            <el-button type="primary" size="mini" btnCode="003P01EB004" @click="daochu" v-if="btnFlg[3]">
              导出
            </el-button>
            <!-- <el-button
              type="primary"
              size="mini"
              btnCode="003P01EB006"
              v-if="btnFlg[5]"
              @click="printChukudan1"
            >
              打印出库单
            </el-button> -->
            <span>总吨数：<span style="color: red">{{ Number(allWeightMaster).toFixed(3) }}</span>吨</span>
            <span style="margin-left:20px">装车费合计：<span style="color: red">{{ Number(allLoadingFee).toFixed(2)
            }}</span>元</span>
          </el-form-item>

        </el-form>

      </div>
    </div>
    <div :style="{ height: h }">
      <el-table size="mini" height="100%" ref="table" :data="tableData" border center bordersize="mini" style="width:100%"
        class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row
        @row-click="dianjixuanzhong" @selection-change="selectGoods">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column type="index" align="center" label="序号" width="60">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" btnCode="003P01EB003" v-if="btnFlg[2]"
                @click="printChukudan2(scope.row)">打印</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="出库单号" width="250px" prop="outstockNo">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="outBillNo" label="外部单号" width="150px"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="outstockUserName" label="出库人" align="center"
          width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="出库日期" width="250px" prop="outstockDate"
          :formatter="dateTimeFormat"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="一级货主" width="250px"
          prop="primaryCustomerName"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="二级货主" prop="customerName" width="250px"></el-table-column>
        <!-- <el-table-column
        :show-overflow-tooltip="true"
          label="货权方"
          prop="ownerCustomerName"
          width="250px"
        ></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" label="车牌号" width="150px"
          prop="outstockPlateNumber"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="装车费(元)" width="100px" prop="loadingFee">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.loadingFee == undefined || scope.row.loadingFee == ''"></span>
              <span v-else>{{ Number(scope.row.loadingFee).toFixed(2) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="司机" width="150px" prop="driverName"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="司机电话" width="150px" prop="telephone"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="身份证号" width="200px" prop="idNumber"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="数据来源" width="100px" prop="sourceName"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="提货单号" width="250px" prop="billNo"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center"
          width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center"
          width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="printDate" label="打印时间" align="center"
          width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center">
          <template v-slot="scope">
            <div>
              <el-button size="small" type="text" @click="chakanbeizhu(scope.row)">查看</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <!--出库单详情-->
    <div>
      <div class="detailsTitle">
        <h4>货物详情</h4>
      </div>
      <div ref="searchBox2" style="margin-top: 5px;margin-left:10px;">
        <span>
          总吨数:
          <span style="color: red">{{ allWeight }}</span> &nbsp;吨
        </span>
        <span style="margin-left: 20px">
          件数:
          <span style="color: red">{{ allNumber }}</span> &nbsp;件
        </span>
      </div>
      <!-- <p class="detailsTitle-sum"><span>总吨数：<span class="num">{{ allWeight }}</span>吨</span><span>总件数：<span class="num">{{allNumber}}</span>件</span></p> -->

      <!--详情表格-->
      <div class="ruKuZuoyeWarp-body-detailsTab">
        <div class="ruKuZuoyeWarp-body-table" :style="{ height: detailsH }">
          <el-table height="100%" size="mini" ref="tabref" border center bordersize="mini" :data="subTableData"
            style="width:100%" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            @row-click="dianjixuanzhong" @select="selectXiangqingTable" @selection-change="changeFun">
            <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="货物类型" width="150px"
              prop="productTypeName"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="placeOfOrigin" label="产地" align="center"
              width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
              width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="150"
              align="center"></el-table-column>
            <!-- <el-table-column
              :show-overflow-tooltip="true"
              prop="root"
              label="单件支数"
              align="center"
            ></el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="length"
              label="长度（m）"
              align="center"
              width="100"
            ></el-table-column> -->
            <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center"
              width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位" align="center"
              width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="总重量（吨）" align="center" width="150">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
                  <span v-else>{{ Number(scope.row.allWeight).toFixed(3) }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="100" align="center">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
                  <span v-else>{{ Number(scope.row.weight).toFixed(3) }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center"
              width="150">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
                  <span v-else>{{ Number(scope.row.weighingWeight).toFixed(3) }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅净重时间" align="center" width="200"
              :formatter="dateTimeFormat"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" align="center"
              width="200"></el-table-column>
          </el-table>
          <!-- 分页-->
          <div class="pags" style="text-align: right;">
            <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo"
              :page-size="pageInfoXQ.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ"
              :total="totalXQ"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="装车费修改" :visible.sync="editZhuangCheVisible" :close-on-click-modal="false" width="50%"
      @close="closeEditZhuangcheCost" center>
      <el-form ref="zhuangcheCostEditFormData" label-width="200px" style="width: 500px; margin: 30px auto"
        :model='zhuangcheCostEditForm'>
        <el-form-item label="车牌号 :" :rules="[
          {
            required: true,
            message: '请先确认车牌号',
            trigger: 'blur',
          },
        ]">
          <span style="width: 200px">{{ zhuangcheCostEditForm.plateNumber }}</span>
        </el-form-item>
        <el-form-item label="原装车费(元):" :rules="[
          {
            required: true,
            message: '请先维护本物料单件理重',
            trigger: 'blur',
          },
        ]">
          <span style="width: 200px">{{ zhuangcheCostEditForm.yuanZhuangcheCost }}</span>
        </el-form-item>
        <el-form-item prop="xianZhuangcheCost" label="现装车费(元)：" :rules="[
          {
            required: true,
            message: '请输入装车费',
            trigger: 'blur',
          },
        ]">
          <el-input v-number-input.float="2" v-model="zhuangcheCostEditForm.xianZhuangcheCost" size="mini"
            style="width: 200px" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeEditZhuangcheCost">取 消</el-button>
        <el-button type="primary" :loading="zhuangcheCostEditLoading" @click="xiecheCostEditRukuOk">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看备注" :visible.sync="dialogBeizhuVisible" width="35%">
      <div v-if="!lookApproverReject">{{ beizhu }}</div>
      <span v-if="lookApproverReject">暂无备注</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBeizhuVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOutstockMasterList, getOutstockSummaryList, updateWhOutstockMasterLwg } from '@/api/wms-access'
import { getRelationCustomer, zidian, getVirtualBalingList } from '@/api/wms-stock'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import {
  dateTimeFormat
} from '@/utils/util'
export default {
  name: 'ChukuReceipts',
  data () {
    return {
      activeName: 'first',
      HWXiangQingLook: true,
      dateTimeFormat: dateTimeFormat, // 列表时间格式化

      searchForm: {
        outstockNo: '',
        outstockDateStart: '',
        outstockDateEnd: '',
        // ownerCustomerTaxId: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        billNo: '',
        outstockPlateNumber: '',
        // productType: '',
        steelMillName: '',
        outBillNo: ''
        // dateStart: '',
        // dateEnd: ''
      },
      OwnerData: [],
      HQData: [], // 货权方
      HWData: [],
      h: '500px',
      tableData: [],
      selectList: [],
      subTableData: [],
      btnFlg: [],
      btnIdArr: [
        '003P01EB001',
        '003P01EB002',
        '003P01EB003',
        '003P01EB004',
        '003P01EB005',
        '003P01EB006',
        '003M2V0100'
      ],
      totalXQ: 0,
      total: 0,
      detailsH: '200px',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      pageInfoXQ: {
        pageNo: 1,
        pageSize: 20
      },
      xuanzhongArr: null,
      xuanzhongArrdown: null,
      allNumber: 0,
      allWeight: 0,
      zhuangcheCostEditLoading: false,
      editZhuangCheVisible: false,
      zhuangcheCostEditForm: {
        xianZhuangcheCost: '',
        plateNumber: '',
        yuanZhuangcheCost: ''
      },
      allWeightMaster: 0,
      allLoadingFee: 0,
      beizhu: '',
      dialogBeizhuVisible: false,
      lookApproverReject: false,
      steelMillNameData: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/ChukuReceipts')
    // console.log(this.btnFlg)
    this.getVirtualBalingLists()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 190 + 'px'
    this.detailsH = 0.4 * pH - h2 - 105 + 'px'
    this.zidians()
    this.getRelationCustomerS()
    this.getOutstockMasterLists()
    // this.detailsH = 0.4 * pH - h2 - 60 + 'px'
  },
  methods: {
    chakanbeizhu (row) {
      this.dialogBeizhuVisible = true
      this.beizhu = row.remark
    },
    daochu () {
      exportExcel(
        this.global.wmsAccessName + '/whOutstockSummary/exportEmptyOutstockMasterList',
        { ...this.searchForm, outstockStatus: '1', ...this.pageInfo },
        '出库单据表'
      )
    },
    xiecheCostEditRukuOk () {
      this.$refs.zhuangcheCostEditFormData.validate((valid) => {
        if (valid) {
          this.zhuangcheCostEditLoading = true
          updateWhOutstockMasterLwg(
            { outstockId: this.zhuangcheCostEditForm.outstockId, loadingFee: this.zhuangcheCostEditForm.xianZhuangcheCost, outstockStatus: '1' }
          )
            .then(res => {
              this.editZhuangCheVisible = false
              this.getOutstockMasterLists()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            })
            .catch(error => {
              this.zhuangcheCostEditLoading = false

              this.$message({
                message: error.message,
                type: 'error'
              })
            })
        } else {
          this.zhuangcheCostEditLoading = false
        }
      })
    },
    editXieCheCost () {
      // if (this.tableData.length == 0) {
      //   DonMessage.error('暂无数据')
      //   return
      // }

      // if (this.xuanzhongArr == null) {
      //   DonMessage.error('请先选择一条数据')
      //   return
      // }
      if (this.selectList.length !== 1) {
        DonMessage.error('请选择一条数据')
        return
      }
      this.editZhuangCheVisible = true
      this.zhuangcheCostEditLoading = false
      this.zhuangcheCostEditForm.xianZhuangcheCost = ''
      this.zhuangcheCostEditForm.plateNumber = ''
      this.zhuangcheCostEditForm.yuanCost = ''
      // this.zhuangcheCostEditForm = this.selectList[0]
      this.$nextTick(() => {
        this.$refs.zhuangcheCostEditFormData.clearValidate()
      })

      this.zhuangcheCostEditForm.outstockId = this.selectList[0].outstockId
      this.zhuangcheCostEditForm.yuanZhuangcheCost = this.selectList[0].loadingFee
      this.zhuangcheCostEditForm.plateNumber = this.selectList[0].outstockPlateNumber
    },
    closeEditZhuangcheCost () {
      this.editZhuangCheVisible = false
    },
    chaxun () {
      this.getOutstockMasterLists()
    },
    chongzhi () {
      this.searchForm.outstockNo = ''
      this.searchForm.outstockDateStart = ''
      this.searchForm.outstockDateEnd = ''
      this.searchForm.primaryCustomerTaxId = ''
      this.searchForm.customerTaxId = ''
      this.searchForm.billNo = ''
      this.searchForm.outstockPlateNumber = ''
      // this.searchForm.ownerCustomerTaxId = ''
      this.searchForm.steelMillName = ''
      this.searchForm.outBillNo = ''
      this.getOutstockMasterLists()
    },
    printChukudan1 () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.$router.push({ // 核心语句
        path: '/chukuDanPrint1', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          id: this.xuanzhongArr.outstockId
        }
      })
    },
    printChukudan () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      if (this.selectList.length == 0) {
        this.$message({
          message: '请选择要打印的数据',
          type: 'error'
        })
        return
      }
      let ids = []
      this.selectList.forEach((item, index) => {
        ids.push(item.outstockId)
      })
      this.$router.push({ // 核心语句
        path: '/chukuDanPrint', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          id: ids
        }
      })
    },
    printChukudan2 (row) {
      this.$router.push({ // 核心语句
        path: '/chukuDanPrint1', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          id: row.outstockId
        }
      })
    },
    // 点击
    dianjixuanzhong (row) {
      // console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      // this.getOutstockMasterLists()
      this.$refs.table.toggleRowSelection(row)
      this.getOutstockSummaryLists()
    },
    dianjixuanzhongdown (row) {
      this.xuanzhongArrdown = {}
      this.xuanzhongArrdown = row
      // this.getOutstockSummaryLists()
    },
    selectGoods (selection) {
      this.selectList = selection
    },
    dianjiXiangqingtable () { },
    selectXiangqingTable () { },
    changeFun () { },
    // 分页
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getOutstockMasterLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getOutstockMasterLists()
    },
    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.getOutstockSummaryLists()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.getOutstockSummaryLists()
    },
    // 出库主列表
    getOutstockMasterLists () {
      getOutstockMasterList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        outstockStatus: 1,
        outstockNo: this.searchForm.outstockNo,
        outstockDateStart: this.searchForm.outstockDateStart,
        outstockDateEnd: this.searchForm.outstockDateEnd,
        primaryCustomerTaxId: this.searchForm.primaryCustomerTaxId,
        customerTaxId: this.searchForm.customerTaxId,
        billNo: this.searchForm.billNo,
        // productType: this.searchForm.productType,
        outstockPlateNumber: this.searchForm.outstockPlateNumber,
        steelMillName: this.searchForm.steelMillName,
        // ownerCustomerTaxId: this.searchForm.ownerCustomerTaxId,
        outBillNo: this.searchForm.outBillNo,
        ...this.pageInfo
      })
        .then(res => {
          console.log(res)
          this.tableData = res.pageInfo.list
          this.allWeightMaster = res.allWeight
          this.allLoadingFee = res.allLoadingFee
          if (res.pageInfo.list.length > 0) {
            this.xuanzhongArr = res.pageInfo.list[0]
            this.$nextTick(() => { if (this.tableData.length > 0) this.$refs.table.setCurrentRow(res.pageInfo.list[0]) })
            this.$nextTick(() => { if (this.tableData.length > 0) this.$refs.table.toggleRowSelection(res.pageInfo.list[0]) })

            this.getOutstockSummaryLists()
          } else {
            this.subTableData = []
            this.allNumber = 0
            this.allWeight = 0
            this.totalXQ = 0
          }
          this.total = res.pageInfo.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物详情
    getOutstockSummaryLists () {
      getOutstockSummaryList({
        outstockId: this.xuanzhongArr.outstockId,
        ...this.pageInfoXQ
      })
        .then(res => {
          console.log(res)
          this.subTableData = res.pageInfo.list
          if (res.pageInfo.list.length > 0) this.xuanzhongArrdown = res.pageInfo.list[0]
          this.$nextTick(() => { this.$refs.tabref.setCurrentRow(res.pageInfo.list[0]) })
          this.totalXQ = res.pageInfo.total
          this.allNumber = res.all.allNumber
          this.allWeight = res.all.allWeight
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.OwnerData = res
          this.HQData = JSON.parse(JSON.stringify(res))
          this.HQData.unshift({ 'custerName': '无货权方', 'taxpayerNumber': '-1' })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 货物类型
    zidians () {
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          // console.log(res)
          this.HWData = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 下拉框
    getVirtualBalingLists () {
      getVirtualBalingList()
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          // this.specificationData = []
          // this.modelData = []
          // this.productTypeData = []
          // var obj = {}
          // for (var i = 0; i < res.length; i++) {
          //   if (!obj[res[i].productTypeName]) {
          //     this.productTypeData.push(res[i])
          //     obj[res[i].productTypeName] = true
          //   }
          // }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          // this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          // this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    }
  }

}
</script>

<style lang="less" scoped>
.controlCargos-search {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}

.ChukuReceipts {
  padding-left: 20px;
}

.detailsTitle-sum {
  padding-left: 20px;

  .num {
    color: rgb(224, 0, 32)
  }
}

/deep/.el-tabs__header{
  margin-bottom: 0;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
    margin-bottom: -6px!important;
  }
}
</style>
